import React from 'react';
import { Col, Row, Input } from 'antd';
import { FormikContextType } from 'formik';
import FormError from 'components/molecules/form-error';
import InputSelect from 'components/organisms/select';
import { SendCommunicationSecondStepForm } from 'types';
import CardSendCommunication from 'components/molecules/card-send-communication';
import { useIntl } from 'common/config/i18n';

type Props = {
  formik: FormikContextType<SendCommunicationSecondStepForm>;
  height?: number;
  handleSelectSituation: (situationId: number) => void;
  handleSelectReason: (situationId: number) => void;
  selectStationsData: Array<{ id: string; list: Array<{ id: number; name: string }> }>;
  reasonsData: Array<{ id: string; list: Array<{ id: number; name: string }> }>;
  isOthersReason: boolean;
  isReasonActive: boolean;
};

const TargetSituation = ({
  formik,
  height,
  handleSelectSituation,
  handleSelectReason,
  selectStationsData,
  isReasonActive,
  reasonsData,
  isOthersReason,
}: Props) => {
  const { t } = useIntl();

  return (
    <CardSendCommunication title={t('form', 'NEW_TITLE8')} height={height} style={{ marginTop: '1rem' }}>
      <Row justify="space-between" align="top" style={{ height: '100%' }}>
        <Col style={{ width: '40%' }}>
          <Row align="middle">
            <div style={{ width: 50 }}>{t('sendCommunication', 'situationSelection', 'situationLabel')}</div>
            <InputSelect
              onChange={(situationId) => handleSelectSituation(situationId as number)}
              value={formik.values.situationId}
              data={selectStationsData}
              style={{ width: '100%' }}
              allowClear={false}
              showSearch
            />
          </Row>
          <FormError formik={formik} fieldName="situationId" />
        </Col>
        <Col style={{ width: '50%', height: '100%' }}>
          {isReasonActive && (
            <>
              <Row align="middle">
                <div style={{ width: 50 }}>{t('sendCommunication', 'situationSelection', 'motifLabel')}</div>
                <InputSelect
                  onChange={(reasonId) => handleSelectReason(reasonId as number)}
                  value={formik.values.reasonId}
                  data={reasonsData}
                  style={{ width: '100%' }}
                  showSearch
                />
              </Row>
              <FormError formik={formik} fieldName="reasonId" />
            </>
          )}
          {isOthersReason && (
            <>
              <Row align="middle" style={{ flexDirection: 'column', alignItems: 'start', marginTop: 10 }}>
                <div style={{ width: 50 }}>{t('sendCommunication', 'situationSelection', 'labelOther')}</div>
                <Input
                  name="otherReasonComplementary"
                  value={formik.values.otherReasonComplementary}
                  onChange={formik.handleChange}
                  style={{ width: '100%' }}
                />
              </Row>
              <FormError formik={formik} fieldName="otherReasonComplementary" />
            </>
          )}
        </Col>
      </Row>
    </CardSendCommunication>
  );
};

export default TargetSituation;
